export default {
  namespaced: true,
  state: {
    recherche: 'recherchesimple',
  },
  mutations: {
    recherche(state, payload) {
      state.recherche = payload.recherche;
    },
  },
};
